export default class featuredMediaLibrary {
    /*
     * Fires first
     */
    constructor() { 

        /*
        * Initialize slider
        */
         $('.js-featured-media-library__video').slick({
            autoplay: false,
            autoplaySpeed: 4500,
            arrows: true,
            dots: true, 
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            fade: true,
            cssEase: 'linear',
            // nextArrow: '<button class="slick-slider__arrow-next w-4 h-8 absolute -right-12 top-1/3 translate-y-1/2 focus:outline-none focus:outline-none bg-center bg-no-repeat bg-contain"></button>',
            // prevArrow: '<button class="slick-slider__arrow-prev w-4 h-8 absolute -left-12 top-1/3 translate-y-1/2 focus:outline-none focus:outline-none bg-center bg-no-repeat bg-contain"></button>',
            responsive: [ 
                {
					breakpoint: 1380,
					settings: { 
                        arrows: false,
					},
				},
			],
        });

        this.addEvents();

        
    }

     /*
     * Add events
     */
     addEvents() {
        /*
        * Stop current video before change slide
        */
        $('.js-featured-media-library__video').on('beforeChange', function(event, slick, currentSlide){
            $(slick.$slides.get(currentSlide)).find('.js-featured-media-library__video-player').get(0).pause();
        });
    }

}